/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialQuickMessage } from '../../models/api-response-referential-quick-message';

export interface GetReferentialQuickMessageByRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getReferentialQuickMessageByRef(http: HttpClient, rootUrl: string, params: GetReferentialQuickMessageByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialQuickMessage>> {
  const rb = new RequestBuilder(rootUrl, getReferentialQuickMessageByRef.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialQuickMessage>;
    })
  );
}

getReferentialQuickMessageByRef.PATH = '/v1/api/ui/referential/quick-message/{ref}';
